import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useTenant } from '../context/TenantContext';
import { BackIcon } from '../components/icons'
import { ListIcon } from '../components/icons';
import DOMPurify from 'dompurify';
import {
  useNavigate,
  useParams,
  Link,
  useSearchParams,
} from "react-router-dom";

const ForgotPasswordGuide = () => {
  const { t } = useLanguage();
  const { tenant } = useTenant();

  const navigate = useNavigate();
  const { tenanturlname } = useParams();

  return (
    <div className="page-wrapper">
  <div className="header">
    <button
      onClick={() => navigate(`/${tenanturlname}/`)}
      className="back-button"
    >
      <BackIcon className="back-icon" />
    </button>
    <h1 className="page-title">
      Detailed password setup instructions
    </h1>
  </div>

  <div className="grid-container-pw">
    <div className="item">
      <h2>1. Step</h2>
      <div className="step-img">
        <img src={require("../assets/images/backgrounds/step-1.png")} alt="step-1" />
      </div>
      <p>Click the login icon at the bottom of the "Visa Discount" home screen to proceed to the login screen.</p>
    </div>

    <div className="item">
      <h2>2. Step</h2>
      <div className="step-img">
        <img src={require("../assets/images/backgrounds/step-2.png")} alt="step-2" />
      </div>
      <p>Click "Forgot your password? New password here" below the login button to proceed.</p>
    </div>

    <div className="item">
      <h2>3. Step</h2>
      <div className="step-img">
        <img src={require("../assets/images/backgrounds/step-3.png")} alt="step-3" />
      </div>
      <p>Enter your registered email address and submit.</p>
    </div>

    <div className="item">
      <h2>4. Step</h2>
      <div className="step-img">
        <img src={require("../assets/images/backgrounds/step-4.png")} alt="step-4" />
      </div>
      <p>If you are registered, a verification email will be sent to your registered email address. Click the verification button or link in the email.</p>
    </div>

    <div className="item">
      <h2>5. Step</h2>
      <div className="step-img">
        <img src={require("../assets/images/backgrounds/step-5.png")} alt="step-5" />
      </div>
      <p>
        Enter your password twice and submit.<br />
        <strong>Your password must meet the following criteria:</strong><br />
        – 12 characters or more<br />
        – Include at least one special character<br />
        – Include at least one uppercase letter<br />
        – Include at least one lowercase letter
      </p>
    </div>

    <div className="item">
      <h2>6. Step</h2>
      <div className="step-img">
        <img src={require("../assets/images/backgrounds/step-6.png")} alt="step-6" />
      </div>
      <p>Once sent, the password is set</p>
    </div>
  </div>
</div>

  );
};

export default ForgotPasswordGuide;
